<template>
	<div>

		<div>
			<!-- BEGIN panel -->
			<div v-show="!rating.length" class="text-center pt-5">
				<h3> Нет данных</h3>
			</div>
			<div v-show="!!rating.length" class="pb-1">
				<h3>История изменения рейтинга:</h3>
			</div>

			<table v-show="!!rating.length" class="table table-hover">
				<thead>
					<tr>
						<th>
							<h5>Дата</h5>
						</th>
						<th>
							<h5>Описание</h5>
						</th>
						<th>
							<h5>Изменение</h5>
						</th>
						<th>
							<h5>Рейтинг</h5>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in rating" v-bind:key="item.id">
						<td>
							{{ item.created_at }}
						</td>
						<td>
							{{ item.comment }}
						</td>
						<td v-if="item.rating_delta >= 0">
							<b class="text-green">+{{ item.rating_delta }}</b>
						</td>
						<td v-else>
							<b class="text-red">{{ item.rating_delta }}</b>
						</td>
						<td>
							{{ item.rating }}
						</td>
					</tr>
					<tr v-if="!rating.length">
						<td colspan="4" align="center">Нет данных </td>
					</tr>
				</tbody>
			</table>
			<!-- END panel -->
			<Paginator :meta="meta" :fetchData="fetchData" />
		</div>
	</div>
</template>


<script>
import HTTP from "../http";
import { show_error } from "../message";


export default {
	data() {
		return {
			loading: false,
			rating: [],
			curr_page: 1,
			meta: { last_page: 1 }
		};
	},

	mounted() {
		this.fetchData(this.curr_page);
	},
	methods: {
		fetchData(page) {
			this.loading = true;
			this.$insProgress.start();
			HTTP()
				.get("/rating?page=" + page)
				.then((resp) => {
					console.log('resp1', resp)
					this.rating = resp.data.data
					this.meta = resp.data.meta
					this.meta.current_page = !this.meta.current_page ? 1 : this.meta.current_page
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
					this.$insProgress.finish();
				});
		},
	}
}
</script>


